mutation UpdateHifoCascadePitch(
  $id: ID!
  $hifoCascadePitchInput: HifoCascadePitchChangeInput!
) {
  updateHifoCascadePitch(
    input: { id: $id, hifoCascadePitchInput: $hifoCascadePitchInput }
  ) {
    hifoCascadePitch {
      id
      status
      committedAmount {
        currency
        minorUnit
      }
      grantedAmount {
        currency
        minorUnit
      }
    }
  }
}
